import axios from 'axios';
import authHeader from '../../auth-header';

import tokenHeader from '../../token-header';

import baseUrl from '../../base-url';

const API_URL = baseUrl() + "/api/all/";

const getDokumen = 'dokumen-pendukung-rekomendasi';
const postDokumenUrl = 'dokumen-pendukung-rekomendasi';
const putDokumen = 'dokumen-pendukung-rekomendasi/';
const deleteDokumen = 'dokumen-pendukung-rekomendasi/';

class DokumenPendukungService {

    postDokumen(formData) {
        return axios
        .post(
            API_URL + postDokumenUrl ,
            formData,
            { headers: authHeader() }
        );
    }

    putDokumen(formData) {
        return axios
        .put(
            API_URL + putDokumen + formData.id_dokumen_pendukung,
            formData,
            { headers: authHeader() }
        );
    }

    deleteDokumen(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteDokumen + formData.id_dokumen_pendukung,
                { headers: authHeader() }
            );
    }

    getDokumen(currentPage, pageSize, filter,idRekomendasi) {

        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
            idRekomendasi : idRekomendasi
        };
        
        return axios.get(
            API_URL + getDokumen ,
        {
            params : data,
            headers: authHeader()
        });
    }

}

export default new DokumenPendukungService();